<template>
  <v-card color tile flat>
    <v-card-text d-flex>{{ setFinding(deviation.importance, deviation.text) }}</v-card-text>

    <v-card-text>
      <span v-if="deviation.geolocation">
        <a style="text-decoration: none;" v-bind:href="deviation.geolocation.href" target="_blank">
          <v-icon color="grey">location_on</v-icon>
        </a>
      </span>
      <span v-if="deviation.media">
        <v-badge color="blue">
          <span slot="badge">{{ deviation.media | objectCount }}</span>
          <v-icon @click="toggleMedia = !toggleMedia" color="grey">attachment</v-icon>
        </v-badge>
      </span>

      <v-spacer></v-spacer>
    </v-card-text>

    <media-carousel-dialog
      v-if="toggleMedia && currentMedia"
      :items="currentMedia"
      :dialogMedia.sync="dialogMedia"
      :context="context"
    ></media-carousel-dialog>

    <v-card-text v-if="toggleMedia">
      <v-container grid-list-xs fluid>
        <v-layout row wrap>
          <v-flex v-for="(media,media_index) in deviation.media" :key="media_index" xs12 sm4 pa-2>
            <!-- TODO: Cusor sollte durch @click gesetzt werden -->
            <v-card
              tile
              v-if="toggleMedia"
              @click="zoom(media, media_index)"
              style="cursor: pointer;"
            >
              <v-img :src="media.url" height="200px"></v-img>
              <v-card-actions v-if="media.descriptiondeactivated">{{ media.description }}</v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<i18n>
{
  "de": {
    "finding_9": "Hauptabweichung",
    "finding_3": "Nebenabweichung",
    "finding_1": "Anmerkung",
    "finding_0": "Bemerkung",
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "en": {
    "audititem_title": "Audit Question",
    "category_label": "Category",
    "chapters_label": "Assigned Standard Chapters",
    "importance_label": "Importance",
    "cancel": "Cancel",
    "save": "Save"   
  }
}
</i18n>

<script>
// Mixins
import FormattingMixin from "@/components/mixins/FormattingMixin.vue";

// Dialogs
import MediaCarouselDialog from "@/components/dialogs/MediaCarouselDialog.vue";

import { mapGetters } from "vuex";
import { api as confApi } from "@/store/modules/configuration";

export default {
  props: {
    deviation: {
      type: Object,
      default: () => {}
    },
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      toggleMedia: false,
      dialogMedia: false,
      currentMedia: null
    };
  },
  mixins: [FormattingMixin],
  components: {
    MediaCarouselDialog
  },
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.finding])
  },
  methods: {
    zoom(media, mediaId) {
      this.currentMedia = [{ ...media, mediaId }];
      this.dialogMedia = !this.dialogMedia;
    },
    currentFindingType(id) {
      const findingtype = {
        "0": {
          description: "0 - Abweichung",
          id: "0",
          text: "Abweichung",
          short: "AB"
        },
        "1": {
          description: "1 - Nebenabweichung",
          id: "1",
          text: "Nebenabweichung",
          short: "NB"
        },
        "2": {
          description: "2 - PA?",
          id: "2",
          text: "PA",
          short: "PA"
        },
        "3": {
          description: "3 - Verbesserungspotential",
          id: "3",
          text: "Verbesserungspotential",
          short: "PA"
        },
        default: {
          description: "Kein Typ definiert",
          id: "",
          text: "Kein Typ definiert",
          short: "-"
        }
      };

      return findingtype[id || "default"];
    },
    setFinding(performance, text) {
      if (performance) {
        const conf = this.finding.data.importance.find(
          setting => setting.id === performance
        ) || { text: "Keine Kategorisierung" };

        return conf.text + ": " + text;
      } else {
        return text;
      }
    }
  }
};
</script>
